import React from "react";
import { Notifications } from "@/integration/application/interfaces/notification.interface";
import { useNavigate } from "react-router-dom";

interface NotificationHeaderProps {
  notification: Notifications;
  compact?: boolean;
}

/**
 * NotificationHeader component
 * Displays the notification title and read/unread indicator
 */
const NotificationHeader: React.FC<NotificationHeaderProps> = React.memo(
  ({ notification, compact = false }) => {
    const navigate = useNavigate();

    return (
      <div className="flex items-start gap-3">
        {/* Read/unread indicator */}
        <div
          className={`min-w-[8px] h-${compact ? "8" : "16"} rounded-full ${
            notification.isRead
              ? compact
                ? "bg-gray-600"
                : "bg-gradient-to-b from-gray-600 to-gray-700"
              : "bg-gradient-to-b from-red-500 to-red-600"
          }`}
          aria-hidden="true"
        />

        {/* Title */}
        <div
          className="flex items-center"
          onClick={() => navigate("/notifications")}
        >
          <h4
            className={`${compact ? "font-medium" : "text-xl font-medium"} bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent`}
          >
            {notification?.title}
          </h4>
        </div>
      </div>
    );
  }
);

NotificationHeader.displayName = "NotificationHeader";

export default NotificationHeader;